import { Box, Button, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { Splash } from '~components/page-header/splash'

import { PageTitleAndTracking } from '~components/page-title-and-tracking'
import { PageWrapper } from '~components/page-wrapper'
import { COLORS } from '~theme/colors'

const content = {
  title: 'Contact',
  subtitle: 'Please contact us for more information',
  contactEmail: 'management.services@maersktankers.com',
  imageLink:
    'https://strmtnoeupvesseltruth01.blob.core.windows.net/public/InSite/background-contact.jpg',
} as const

const MIN_HEIGHT = 320
export default function Contact() {
  return (
    <>
      <PageTitleAndTracking title={`InSite | ${content.title}`} />
      <Splash pageName={content.title} omitPoolSelector />
      <PageWrapper>
        <FullHeightCard>
          <Typography variant="h1" sx={{ mt: 4, mb: 5 }}>
            {content.subtitle}
          </Typography>

          <Button
            variant="contained"
            component="a"
            href={`mailto:${content.contactEmail}`}
          >
            Get in Touch
          </Button>
        </FullHeightCard>
      </PageWrapper>
    </>
  )
}

export function FullHeightCard({
  disableFullHeight,
  children,
}: {
  disableFullHeight?: boolean
  children: React.ReactNode
}) {
  const boxRef = useRef<HTMLDivElement | null>(null)
  const [heightPx, setHeightPx] = useState<number | undefined>()

  useEffect(() => {
    if (disableFullHeight) return

    const footer = document.querySelector('footer') as HTMLElement | null
    const box = boxRef.current
    if (!box || !footer) return

    const boxTop = box.getBoundingClientRect().top
    const footerTop = footer.getBoundingClientRect().top
    const available = Math.max(0, footerTop - boxTop)
    const height = available > MIN_HEIGHT ? available : MIN_HEIGHT
    setHeightPx(height)
  }, [])

  return (
    <Box
      ref={boxRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        flexGrow: 1,
        ...(heightPx ? { height: `${heightPx}px` } : {}),
      }}
    >
      <Box
        sx={{
          background: COLORS.greys.light,
          p: 2,
          borderRadius: 2,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
